<div class="modal-header">
    <h4 class="modal-title roboTitle" id="modal-basic-title">{{'configuration.rubrica.search' | translate}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="close()">
      <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body" style="padding: 10px">
    <div style="display: flex; flex-direction: row;align-items: baseline;flex-wrap: wrap;">
        <div *ngIf="innerWidth! <= 767" class="break" style="margin-bottom: 10px;"></div>
        <div class="input-group" style="margin-left: 10px; flex: 1;">
            <input type="text" [ngClass]="( titleSearch.length > 3 ) ? '' : 'borderRed'" [ngStyle]="{'border-radius': '10px 0px 0px 10px'}" [(ngModel)]="titleSearch" (keyup)="search($event)" class="form-control" [placeholder]="'configuration.rubrica.search' | translate" aria-label="Cerca per denominazione" aria-describedby="basic-addon1">
            <span class="input-group-text" id="basic-addon1" (click)="search(null)"><i class="bi bi-search"></i></span>
        </div>
    </div>
   
    <div style="margin: 0;margin-top: 5px;overflow-y: auto; max-height: 40vh;">
        <app-loading *ngIf="loading"></app-loading>
        <div class="col-12 text-center" *ngIf="haserror">Nessun risultato</div>
        <table class="table" *ngIf="((listAziende && listAziende.length > 0) && !loading)">
            <thead>
                <tr>
                    <th scope="col" style="max-width: 40px; width: 40px;"></th>
                    <th scope="col">{{ 'users.personal.denominazione' | translate }}</th>
                    <th scope="col">{{ 'users.personal.piva' | translate }}</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let azienda of listAziende" (click)="azienda.selected = true; selectOne(azienda)" style="cursor: pointer;">
                    <td>
                        <input type="checkbox" class="form-check-input" style="margin-left: 0;" [checked]="azienda.selected" (ngModelChange)="selectOne(azienda)">
                    </td>
                    <td>
                        <h5>{{azienda.name}}</h5>
                    </td>
                    <td>
                        <h5>{{azienda.partitaiva}}</h5>
                    </td>
                </tr>
            </tbody>    
        </table>
    </div>

</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="close()">Chiudi</button>
    <button type="button" class="btn btn-outline-dark" (click)="save()">Salva </button>
</div>